export const SET_SINGLE_COMPANY_DETAILS = "SET_SINGLE_COMPANY_DETAILS";
